import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);//使用vuex
//创建store
const store = new Vuex.Store({
	state:{
		login:0,
		fullname:'',
		address:{},
		is_modify_address:false
	},
	mutations:{
		checkLogin:function(state,data){
			state.login = data;
			state.fullname =localStorage.getItem('fullname');
		},
		selectAddress:function(state,data){
			state.address = data;
		},
		modifyAddress:function(state,data){
			state.is_modify_address = data;
		}
	},
	actions:{
		checkLoginFun(context,data){
			context.commit('checkLogin',data);
		},
		selectAddressFun(context,data){
			context.commit('selectAddress',data);
		},
		modifyAddressFun(context,data){
			context.commit('modifyAddress',data);
		},
	}
})
export default store //导出store



// WEBPACK FOOTER //
// ./src/store/index.js